module.exports = __webpack_public_path__ + "static/newsletterguide-logo-full-fa20399558d076ef46aedf5f4c3e2a74.svg";